import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export const YupInventory = () => {
  //page hook
  const { t } = useTranslation();
  return {
    productName: Yup.string().required(
      t("validation.required", {
        productName: t("page.product_name"),
      })
    ),
    sukCode: Yup.string().required(
      t("validation.required", {
        sukCode: t("page.main_group"),
      })
    ),
    stockAmount: Yup.string().required(
      t("validation.required", {
        stockAmount: t("page.sub_group"),
      })
    ),
    expiryDate: Yup.string().required(
      t("validation.required", {
        expiryDate: t("page.sub_group"),
      })
    ),
    batchNumber: Yup.string().required(
      t("validation.required", {
        batchNumber: t("page.sub_group"),
      })
    ),
  };
};
